import { render, staticRenderFns } from "./case-parties-list.vue?vue&type=template&id=97a2ee78&scoped=true&"
import script from "./case-parties-list.vue?vue&type=script&lang=js&"
export * from "./case-parties-list.vue?vue&type=script&lang=js&"
import style0 from "./case-parties-list.vue?vue&type=style&index=0&id=97a2ee78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a2ee78",
  null
  
)

export default component.exports